module.exports = __webpack_public_path__ + "img/box-winning.a45c995c.jpg";